import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { filter } from 'rxjs/operators';
import { OmnisearchModel } from '../../../models/search/omnisearch.model';
import { MvdModalService } from '../../../services/modal/mvd-modal.service';
import { SearchCriteriaComponent } from '../search-criteria/search-criteria.component';
import { SearchResultsModalComponent, SearchResultsModalData } from '../search-results/search-results-modal.component';
import { VehicleGenericModalComponent, VehicleGenericModalData } from '../vehicle-generic-modal/vehicle-generic-modal.component';

@Component({
    selector: 'omnisearch',
    templateUrl: './omnisearch.html'
})
export class OmnisearchComponent {
    @Input() context: number;
    @Input() noSelection: boolean;
    @Input() placeholder: string;
    @Input() title: string;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() onResultsReceived: EventEmitter<any> = new EventEmitter<any>();
    @Output() onSearchCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onSearchStringUsed: EventEmitter<string> = new EventEmitter<string>();

    public searchString: string;
    private results: any;

    @ViewChild(SearchCriteriaComponent, { static: true }) searchCriteriaComponent: SearchCriteriaComponent;

    constructor(public modalService: MvdModalService) {}

    /**
     * Handler for the results from the omnisearch
     * @param data: Data from the omnisearch.
     */
    receiveSearchCriteriaResults(data: any) {
        this.results = data;
        this.onResultsReceived.emit(data);
        if (!this.noSelection && !!data) {
            if (!!data.validationResults && Array.isArray(data.validationResults) && (!data.result || data.validationResults.length)) {
                if (data.validationResults.length > 0 && data.validationResults[0].state && data.validationResults[0].state.validationResourceId === 4834) {
                    this.displayGenericSearchModal();
                } else {
                    this.onSelected.emit(data.validationResults);
                }
            } else if (!!data.result && data.result.length > 1) {
                this.displayModal();
            } else if (!!data.result && data.result.length === 1) {
                this.onSelected.emit(data.result[0]);
            }
        }
    }

    searchCompleted(value: boolean) {
        this.onSearchCompleted.emit(value);
    }

    search() {
        this.searchCriteriaComponent.search();
    }

    getSearchString(search: string) {
        this.searchString = search;
        this.onSearchStringUsed.emit(search);
    }

    displayGenericSearchModal() {
        const data = new VehicleGenericModalData(this.title, this.results, this.searchString);
        this.modalService.open(VehicleGenericModalComponent, data).afterClosed()
            .pipe(filter((genResult: OmnisearchModel | number) => !!genResult))
            .subscribe(acceptedValue => this.onSelected.emit(acceptedValue));
    }

    displayModal() {
        const data = new SearchResultsModalData(this.title, this.results.result, this.searchString, this.context);
        this.modalService.open(SearchResultsModalComponent, data).afterClosed()
            .pipe(filter(result => !!result)).subscribe(acceptedValue => this.onSelected.emit(acceptedValue));
    }
}
